import { BespokeProductsApiClient } from '@fourthwall/services/dist/BespokeProductsApiClient'
import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

export type UseBespokeProductsQueryResponse = Awaited<
  ReturnType<typeof BespokeProductsApiClient.getAll>
>['data']

export type UseBespokeProductsQueryKey = Readonly<[string]>

export type UseBespokeProductsQueryOptions = UseQueryOptions<
  UseBespokeProductsQueryResponse,
  unknown,
  UseBespokeProductsQueryResponse,
  UseBespokeProductsQueryKey
>

const queryFn = async () => {
  const { data } = await BespokeProductsApiClient.getAll()

  return data
}

export const useBespokeProductsQuery = (options?: UseBespokeProductsQueryOptions) => {
  const bespokeProductsQuery = useQuery<
    UseBespokeProductsQueryResponse,
    unknown,
    UseBespokeProductsQueryResponse,
    UseBespokeProductsQueryKey
  >({ queryKey: ['useBespokeProductsQuery'], queryFn: () => queryFn(), ...options })

  return {
    bespokeProducts: bespokeProductsQuery.data,
    bespokeProductsQuery,
  }
}
